import { cva, type VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

const chipVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      tone: {
        dark: 'bg-primary text-primary-contrast',
        // White, whatever the brand: --color-primary-contrast is the text on primary only.
        muted: 'bg-ink-muted text-white',
        light: 'bg-page text-ink border border-line',
        success: 'bg-success/10 text-success',
        danger: 'bg-danger/10 text-danger',
      },
    },
    defaultVariants: { tone: 'light' },
  },
)

export function Chip({
  className,
  tone,
  ...props
}: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof chipVariants>) {
  return <span className={cn(chipVariants({ tone }), className)} {...props} />
}
